export default __webpack_public_path__ + "static/media/memoriesLogo.1b91c0ad.png";